module.exports = __webpack_public_path__ + "img/guidelist-echart1-bg.66832454.png";